import { render } from "./deleteFav.vue?vue&type=template&id=45c5d07d"
import script from "./deleteFav.vue?vue&type=script&lang=js"
export * from "./deleteFav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__